// extracted by mini-css-extract-plugin
export default {"icon":"styles-icon-b48c68"};